import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class PdpAvailabilityBadge extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  updateBadge = (event) => {
    const newBadge = event.detail.data.html.querySelector('pdp-availability-badge');
    if (!newBadge) return;
    morph(this, newBadge, { childrenOnly: true });
  };
}

if (!customElements.get('pdp-availability-badge')) {
  customElements.define('pdp-availability-badge', PdpAvailabilityBadge);
}
